import { useEffect, useRef } from "react";
import { Rect, Transformer } from "react-konva";

export type RectLayerAttr = {
  id: string;
  color: string;
  width: number;
  corderRadius: number;
  opacity: number;
  height: number;
  x: number;
  y: number;
};

type Props = {
  shapeAttr: RectLayerAttr;
  isSelected: boolean;
  onSelect: () => void;
  onChange: (newRectAttr: RectLayerAttr) => void;
};

const RectLayer = ({ shapeAttr, onChange, onSelect, isSelected }: Props) => {
  const rectRef = useRef<any>(null);
  const transformerRef = useRef<any>(null);

  useEffect(() => {
    if (isSelected && transformerRef.current && rectRef.current) {
      const node = rectRef.current;
      transformerRef.current.nodes([node]);
      transformerRef.current.getLayer()?.batchDraw();
    }
  }, [isSelected, shapeAttr]);

  return (
    <>
      <Rect
        ref={rectRef}
        onClick={onSelect}
        onTap={onSelect}
        cornerRadius={shapeAttr.corderRadius}
        opacity={shapeAttr.opacity}
        width={shapeAttr.width}
        height={shapeAttr.height}
        fill={shapeAttr.color}
        x={shapeAttr.x}
        y={shapeAttr.y}
        draggable
        onDragEnd={(e) => {
          onChange({
            ...shapeAttr,
            x: e.target.x(),
            y: e.target.y(),
          });
        }}
        onTransformEnd={() => {
          const node = rectRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          // Reset scale so future transforms start from normal scale
          node.scaleX(1);
          node.scaleY(1);

          onChange({
            ...shapeAttr,
            x: node.x(),
            y: node.y(),
            width: Math.max(20, node.width() * scaleX),
            height: Math.max(20, node.height() * scaleY),
          });
        }}
        hitStrokeWidth={20}
      />
      {isSelected && (
        <Transformer
          ref={transformerRef}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 20 || newBox.height < 20) return oldBox;
            return newBox;
          }}
          rotateEnabled={false}
          keepRatio={true}
          anchorSize={12}
          borderStroke="#007bff"
          borderStrokeWidth={2}
        />
      )}
    </>
  );
};

export default RectLayer;
